var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuCoupon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Material/Icons/\uCFE0\uD3F0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Material/Icons/\\uCFE0\\uD3F0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u110C\\u1161\\u1109\\u1161\\u11AB-38",
    transform: "translate(1.136139, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3711401,1.47653536 C15.0262391,1.38911806 14.6686229,1.44156844 14.3634571,1.62435006 C14.002662,1.85481385 13.171403,2.99123875 12.2813359,4.41693544 C13.9581587,4.31044527 15.3536567,4.11653781 15.7303457,3.9083257 C16.0339222,3.72713347 16.2500813,3.43786168 16.3359092,3.0929607 C16.4233265,2.74805972 16.3708761,2.39044349 16.1880945,2.08527764 C16.0053129,1.7801118 15.7160411,1.56395266 15.3711401,1.47653536 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50040432,1.62435006 C7.19523848,1.44156844 6.83762225,1.38911806 6.49272127,1.47653536 C6.14782028,1.56395266 5.85854849,1.7801118 5.67576686,2.08527764 C5.49298524,2.39044349 5.44053486,2.74805972 5.52795216,3.0929607 C5.61536946,3.43786168 5.8315286,3.72713347 6.13351563,3.9083257 C6.50861532,4.11653781 7.90411331,4.31044527 9.58252546,4.41693544 C8.69245841,2.99123875 7.86119936,1.85481385 7.50040432,1.62435006 L7.50040432,1.62435006 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23629905,0.390971433 C6.92503955,-0.391016049 5.22596512,0.0365340176 4.44238824,1.34779351 C3.65881135,2.65905301 4.08795082,4.35812744 5.39921032,5.14011492 C6.13192623,5.57720142 8.14093472,5.7742877 9.77484352,5.8632944 C9.90358536,5.62806239 10.3549765,4.8142868 10.9303413,3.87494818 C10.07842,2.48421841 8.96265734,0.826468527 8.23470964,0.390971433 L8.23629905,0.390971433 Z M5.52795216,3.09137129 C5.44053486,2.74647031 5.49298524,2.38885408 5.67576686,2.08368824 C5.85854849,1.77852239 6.14782028,1.56236325 6.49272127,1.47494595 C6.83762225,1.38752865 7.19523848,1.43997903 7.50040432,1.62276066 C7.86119936,1.85322445 8.69245841,2.98964935 9.58252546,4.41534603 C7.90570271,4.30885587 6.51020473,4.1149484 6.13351563,3.90673629 C5.82993919,3.72554407 5.61378005,3.43627228 5.52795216,3.09137129 L5.52795216,3.09137129 Z",
    id: "Shape",
    fill: "#F95F53",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4198837,1.34779351 C16.6378963,0.0365340176 14.9388218,-0.391016049 13.6275623,0.390971433 C12.8996146,0.824879121 11.783852,2.48262901 10.9319307,3.87494818 C11.5072955,4.8142868 11.9586866,5.62806239 12.0874285,5.8632944 C13.7213373,5.7742877 15.7319352,5.57720142 16.4630617,5.14011492 C17.7743212,4.35653803 18.2034606,2.65905301 17.4198837,1.34779351 Z M16.3359092,3.09137129 C16.2484919,3.43627228 16.0323328,3.72554407 15.7303457,3.90673629 C15.3552461,4.1149484 13.9597481,4.30885587 12.2813359,4.41534603 C13.171403,2.98964935 14.002662,1.85322445 14.3634571,1.62276066 C14.6686229,1.43997903 15.0262391,1.38752865 15.3711401,1.47494595 C15.7160411,1.56236325 16.0053129,1.77852239 16.1880945,2.08368824 C16.3708761,2.38885408 16.4233265,2.74647031 16.3359092,3.09137129 Z",
    id: "Shape",
    fill: "#F95F53",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77643293,5.8632944 C10.1976254,5.88554608 10.5902085,5.90144013 10.9319307,5.91256597 C11.2752423,5.90144013 11.666236,5.88713548 12.0874285,5.8632944 C11.9586866,5.62806239 11.5072955,4.8142868 10.9319307,3.87494818 C10.3565659,4.8142868 9.90517477,5.62806239 9.77643293,5.8632944 L9.77643293,5.8632944 Z",
    id: "Path",
    fill: "#F95F53",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.79601143 L0,11.106743 L8.01060347,11.106743 L8.01060347,6.99177227 L0.804239158,6.99177227 C0.360795037,6.99177227 0,7.35256731 0,7.79601143 Z",
    id: "Path",
    fill: "#FFE98A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8638614,11.106743 L21.8638614,7.78488559 C21.8638614,7.34620969 21.5078346,6.99018287 21.0691587,6.99018287 L13.8532579,6.99018287 L13.8532579,11.1051536 L21.8638614,11.1051536 L21.8638614,11.106743 Z",
    id: "Path",
    fill: "#FFE98A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F95F53",
    fillRule: "nonzero",
    points: "9.28530664 6.99177227 9.28530664 11.106743 9.28530664 12.1843599 9.28530664 24 12.5785547 24 12.5785547 12.1843599 12.5785547 11.106743 12.5785547 6.99177227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.847153105,12.1843599 L0.847153105,23.1957608 C0.847153105,23.639205 1.20635874,24 1.65139226,24 L8.01060347,24 L8.01060347,12.1843599 L0.847153105,12.1843599 Z",
    id: "Path",
    fill: "#FFE98A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0167083,23.2052973 L21.0167083,12.1843599 L13.8532579,12.1843599 L13.8532579,24 L20.2220056,24 C20.6606815,24 21.0167083,23.6439732 21.0167083,23.2052973 Z",
    id: "Path",
    fill: "#FFE98A",
    fillRule: "nonzero"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCoupon);
export default __webpack_public_path__ + "static/media/menu_coupon.1908431e05bab0affcb9c47b1e4fbdc3.svg";
export { ForwardRef as ReactComponent };